import OptionsControl from 'src/themes/cosmos/components/OptionsControl';
import useSubtitle from 'src/hooks/useSubtitle';
import { ISubtitleStyle } from 'src/interfaces/Subtitle';
import { SUBTITLE_SIZE_OPTIONS } from './constants';

const sizeOptions = SUBTITLE_SIZE_OPTIONS.map((size) => ({
  label: `${size}%`,
  value: size,
}));

const SubtitleSizeControl = () => {
  const { subtitleStyle, saveUpdatedSubtitleStyle } = useSubtitle();

  return (
    <OptionsControl
      selectedOptionValue={subtitleStyle.size}
      onChange={(size) => {
        saveUpdatedSubtitleStyle({ size } as Partial<ISubtitleStyle>);
      }}
      options={sizeOptions}
    />
  );
};

export default SubtitleSizeControl;
